// Curadoria Eco Collection: ligação experiência → parceiro da Rede Local (admin é a fonte da verdade dos parceiros)
export const EXPERIENCE_PARTNERS = {
  'north-tour-cocoa-route': 'Navetur Equatur',
  'wild-south-pico-cao-grande': 'Navetur Equatur',
  'ilheu-santana-by-boat': 'Navetur Equatur',
  'santiago-grand-island-tour': 'Santiago Adventures',
  'authentic-northern-santiago': 'Santiago Adventures',
  'traditional-fishing-beach-bbq': 'Santiago Adventures',
  'tarrafal-boat-swimming': 'Santiago Adventures',
  'cachupa-cooking': 'Santiago Adventures',
  'santiago-community-ecotourism': 'Santiago Adventures',
  'serra-malagueta-vale-principal-trek': 'Guia Maria Tavares',
  'serra-malagueta-mato-brasil-trek': 'Guia Maria Tavares',
  'pico-de-antonia-challenge': 'Guia Maria Tavares',
};
